'use client'

import { ReactNode } from 'react'

import NotificationsUiList from '@/common/components/Notifications/NotificationsUiList/NotificationsUiList'

interface ConfigNotificationProviderProps {
  children: ReactNode
}

const ConfigNotificationProvider: React.FC<ConfigNotificationProviderProps> = ({
  children,
}) => {
  return (
    <>
      {children}
      <NotificationsUiList />
    </>
  )
}

export default ConfigNotificationProvider
